<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      option: null,
      statusPreloader: false,
      textField: false,
      possibleOperations: [
        {
          text: "Inativacao",
          value: "INATIVACAO"
        },
        {
          text: "Desligamento",
          value: "DESLIGAMENTO"
        }
      ],
      possibleDescriptions: [
        {
          text: "Novo trabalho",
          value: "Novo trabalho"
        },
        {
          text: "Saúde",
          value: "Saúde"
        },
        {
          text: "Familia",
          value: "Familia"
        },
        {
          text: "Viagem",
          value: "Viagem"
        },
        {
          text: "Sumiu",
          value: "Sumiu"
        },
        {
          text: "Nao tem interesse",
          value: "Nao tem interesse"
        },
        {
          text: "Gravidez",
          value: "Gravidez"
        },
        {
          text: "Descumprimento de regras (qualidade)",
          value: "Descumprimento de regras (qualidade)"
        },
        {
          text: "Descumprimento de regras (postura)",
          value: "Descumprimento de regras (postura)"
        }
      ]
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    },

    professional: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState("professionals", ["event", "description", "operation"])
  },

  methods: {
    ...mapActions("professionals", [
      "setDescription",
      "setOperation",
      "resetToDefaultState"
    ]),
    ...mapActions("management", ["activate", "deactivate", "block", "unblock"]),

    showTextField() {},

    commitOption(description) {
      this.option = description;
    },

    async changeStatus(to) {
      this.statusPreloader = true;
      this.setDescription(this.option);

      const params = {
        account_id: this.professional.account.id,
        description: this.description
      };

      try {
        switch (this.event) {
          case "activate":
            await this.activate(params);
            break;
          case "deactivate":
            await this.deactivate({ ...params, operation: this.operation });
            break;
          case "block":
            await this.block({ ...params, operation: this.operation });
            break;
          case "unblock":
            await this.unblock({ ...params, operation: this.operation });
            break;
        }
      } catch (e) {}
      this.statusPreloader = false;
      this.closeDialog();
    },

    closeDialog() {
      this.resetToDefaultState();
      this.$emit("close");
    }
  }
};
</script>

<template>
  <v-dialog v-model="visible" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline text-uppercase font-weight-medium">
          Motivo do evento
        </span>
        <v-spacer></v-spacer>
        <v-btn color="accent" rounded icon outlined @click="closeDialog()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-container fluid>
        <v-select
          v-if="this.event != 'activate'"
          required
          autofocus
          label="Selecione uma operação"
          name="operation"
          prepend-inner-icon="mdi-account-reactivate"
          :items="possibleOperations"
          @input="setOperation"
        />
        <v-radio-group v-model="option" v-if="this.event != 'activate'">
          <v-radio
            v-for="description in possibleDescriptions"
            :key="description.value"
            :label="description.text"
            :value="description.value"
            @change="textField = false"
          ></v-radio>

          <v-radio @change="textField = true" :label="'outro'"></v-radio>
        </v-radio-group>

        <v-text-field
          v-if="textField == true || this.event === 'activate'"
          required
          name="description"
          label="Descricao"
          data-vv-as="Descricao"
          prepend-inner-icon="mdi-format-title"
          v-validate="'required|max:100'"
          :counter="100"
          :value="description"
          :error="errors.has('title')"
          :error-messages="errors.first('title')"
          @input="commitOption"
        />
        <div class="btn">
          <v-btn
            color="warning"
            large
            :loading="statusPreloader"
            @click="changeStatus(event)"
          >
            <span>Enviar</span>
          </v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.btn {
  margin-top: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Forms/Description.vue